import { useEffect, useState } from 'react';

type BreakpointType = 'xl' | 'lg' | 'md' | 'sm' | 'xs';

const getBreakpoint = (): BreakpointType => {
  const width = window.innerWidth;
  return 1280 < width ? 'xl' : 1024 < width ? 'lg' : 768 < width ? 'md' : 600 < width ? 'sm' : 'xs';
};

export default function useBreakpoint(): BreakpointType {
  const [breakpoint, setBreakpoint] = useState(getBreakpoint());

  useEffect(() => {
    const onResize = () => {
      setBreakpoint(getBreakpoint());
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return breakpoint;
}
